import React from 'react';

const LeftTableHeader = ({
    perPage, 
    handleItemPerPageSelect, 
    paginationDropdownOptions, 
    planBoardData, 
    handleSort, 
    sortDirectionANumber, 
    sortDirectionChassisNummer,
    sortDirectionLicencePlate,
    sortDirectionReceiptDatePlanned,
    sortDirectionDeliveryDate,
    sortDirectionModel,
    sortDirectionVestigingen,
    sortDirectionCustomer,
}) => {
    return (
        <div className="custom-sticky-position">

            <div className="row row-heading">
                <div className="col-xl-2">
                    <select className="form-select form-select-sm select-record-per-page" value={perPage} onChange={handleItemPerPageSelect}>
                        {
                            paginationDropdownOptions?.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="col-xl-10">
                    {perPage} out of {planBoardData?.totalItems ? planBoardData.totalItems : 0} record shown
                </div>
            </div>
            <div className="row row-heading">
                <div className="col-xl-3"></div>
                <div className="col-xl-3"></div>
                <div className="col-xl-3"></div>
                <div className="col-xl-3"></div>
            </div>
            <div className="row row-heading">
                <div className="filter-item filter-item--small" onClick={() => handleSort("a_number", sortDirectionANumber === 'asc' ? 'desc' : 'asc')}>
                    OM {sortDirectionANumber === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionANumber === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item filter-item--small" onClick={() => handleSort("chassis_no", sortDirectionChassisNummer === 'asc' ? 'desc' : 'asc')}>
                    Chassis {sortDirectionChassisNummer === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionChassisNummer === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item filter-item--small" onClick={() => handleSort("license_plate", sortDirectionLicencePlate === 'asc' ? 'desc' : 'asc')}>
                    Kenteken {sortDirectionLicencePlate === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionLicencePlate === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item filter-item--large" onClick={() => handleSort("customer", sortDirectionCustomer === 'asc' ? 'desc' : 'asc')}>
                    Klantnaam {sortDirectionCustomer === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionCustomer === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item" onClick={() => handleSort("receipt_date_planned", sortDirectionReceiptDatePlanned === 'asc' ? 'desc' : 'asc')}>
                    CDD {sortDirectionReceiptDatePlanned === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionReceiptDatePlanned === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item" onClick={() => handleSort("planned_delivery_date", sortDirectionDeliveryDate === 'asc' ? 'desc' : 'asc')}>
                    Afleverdatum {sortDirectionDeliveryDate === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionDeliveryDate === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item" onClick={() => handleSort("model", sortDirectionModel === 'asc' ? 'desc' : 'asc')}>
                    Model {sortDirectionModel === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionModel === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
                <div className="filter-item filter-item--xtrasmall" onClick={() => handleSort("vestigingen", sortDirectionVestigingen === 'asc' ? 'desc' : 'asc')}>
                    VGTC {sortDirectionVestigingen === "desc"
                        ? <i className="fa-solid fa-arrow-down"></i>
                        : sortDirectionVestigingen === "asc"
                            ? <i className="fa-solid fa-arrow-up"></i>
                            : null}
                </div>
            </div>
        </div>
    );
};

export default LeftTableHeader;